<template>
  <el-dialog :visible.sync="modeDialog" width="1000px" @close="handleHideDialog">
    <template #title>
      <h2>{{$t('lang.工作模式')}}</h2>
    </template>

    <div class="list-box">
      <div
          class="list-item"
          :class="{'active-item': current === index}"
          v-for="(item, index) in modeList"
          @click="current = index"
          :key="item.value">
        <div class="item-card">
          <img :src="current === index ? item.activeIcon : item.icon" class="item-cover"/>
          <div class="item-desc" v-if="item.desc">{{ $t('lang.' + item.desc)}}</div>
        </div>
        <span style="font-weight: 700">{{ item.name }}</span>
      </div>
    </div>

    <div class="footer">
      <el-button type="primary" @click="handleSelect">{{ $t('lang.确认') }}</el-button>
      <el-button @click="handleHideDialog">{{ $t('lang.取消') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {filterModeByDict} from "./mode_config"

export default {
  name: "ModeList",
  data() {
    return {
      modeDialog: false,
      modeList: [],
      current: null,
      callback: null
    }
  },
  methods: {
    handleSelect() {
      if(this.current === null) {
        this.$message.error("请选择工作模式");
        return;
      }
      let mode = this.modeList[this.current];
      if(typeof this.callback ==='function') {
        this.callback(mode);
      }
      this.handleHideDialog();
    },

    showDialog(list, active, cb) {
      this.modeList = filterModeByDict(list);
      if(active) {
        this.current = this.modeList.findIndex(item => item.value === active);
      }
      this.callback = typeof cb === "function" ? cb : null;
      this.modeDialog = true;
    },

    handleHideDialog() {
      this.current = null;
      this.modeDialog = false;
    }
  }

}
</script>

<style scoped lang="scss">

h2 {
  padding: 0;
  margin: 0;
}

.list-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  max-height: 700px;
  overflow-y: auto;
}

.list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}


.item-card {
  width: 300px;
  min-height: 160px;
  overflow-y: hidden;
  box-sizing: border-box;
  padding: 16px;
  border: 1px solid #dddddd;
  display: flex;
  align-items: center;
  column-gap: 18px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.item-cover {
  width: 80px;
  height: 80px;
}

.item-desc {
  line-height: 20px;
}

.active-item {
  color: #409eff;

  .item-card {
    border-color: #409eff;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
}

</style>
